<template>
	<OfferStatTile>
		<template v-slot:icon>
			<img :src="`${network?.image}`" :alt="selectedOffer.network.name" class="mx-2 w-75" />
		</template>
		<template v-slot:title>Provider</template>
	</OfferStatTile>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import OfferStatTile from './Offer-Stat-Tile.vue';
import { Offer } from "@/interfaces/Offers/Offer";
import { NETWORK_DATA } from '@/constants/Networks/NetworkData';

const props = defineProps({
	offer: {
		type: Object as () => Offer,
		default: null,
	}
});

const selectedOffer = computed(() => props.offer);

const network = computed(
	() => NETWORK_DATA[selectedOffer.value.network_id as keyof typeof NETWORK_DATA]
)

</script>